// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderEdit from "./OrderEdit.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as OrderEditForm from "../../modules/Order/OrderEditForm.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as OrderEdit__Utils from "./OrderEdit__Utils.res.js";
import * as Accounting__Maker from "@wino/accounting/src/Accounting__Maker.res.js";
import * as OrderEdit__Queries from "./OrderEdit__Queries.res.js";
import * as Accounting__Computer from "@wino/accounting/src/Accounting__Computer.res.js";
import * as Accounting__Formatter from "@wino/accounting/src/Accounting__Formatter.res.js";
import * as Accounting__Serializer from "@wino/accounting/src/Accounting__Serializer.res.js";

let initialCart = Accounting__Formatter.make(Accounting__Computer.make(Accounting__Maker.Cart.make(OrderEditForm.initialCart)));

function makeInitialOrder(supplierIdOpt, shopIdOpt, deviceIdOpt, param) {
  let supplierId = supplierIdOpt !== undefined ? supplierIdOpt : "";
  let shopId = shopIdOpt !== undefined ? shopIdOpt : "";
  let deviceId = deviceIdOpt !== undefined ? deviceIdOpt : "";
  return {
    TAG: "Data",
    _0: {
      name: "Draft",
      statuses: ["DRAFT"],
      updatedAt: undefined,
      initialValues: {
        condition: "",
        noteForSupplier: "",
        supplierId: supplierId,
        issueDate: new Date(Date.now()),
        estimatedReceptionDate: new Date(Date.now()),
        note: "",
        cart: initialCart,
        shopId: shopId,
        deviceId: deviceId,
        supplierName: "",
        supplierAddress: "",
        supplierPostalCode: "",
        supplierCity: "",
        supplierCountry: ""
      },
      updatedStocks: undefined,
      receptionFinishedAt: new Date(Date.now())
    }
  };
}

function useQuery(orderId, orderQuery, authState, supplierId, shopId) {
  let skipOrderVariantsStockQuery;
  if (orderQuery.TAG === "Executed") {
    let match = orderQuery._0;
    let match$1 = match.data;
    let exit = 0;
    if (match$1 !== undefined) {
      let match$2 = match$1.order;
      if (match$2 !== undefined) {
        skipOrderVariantsStockQuery = !OrderEdit.isBeforeReception(match$2.formattedStatus);
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      let match$3 = match.previousData;
      if (match$3 !== undefined && match$3.TAG === "Ok") {
        let match$4 = match$3._0.order;
        skipOrderVariantsStockQuery = match$4 !== undefined ? !OrderEdit.isBeforeReception(match$4.formattedStatus) : true;
      } else {
        skipOrderVariantsStockQuery = true;
      }
    }
  } else {
    skipOrderVariantsStockQuery = true;
  }
  let tmp;
  if (orderQuery.TAG === "Executed") {
    let match$5 = orderQuery._0;
    let match$6 = match$5.data;
    let exit$1 = 0;
    if (match$6 !== undefined && match$6.order !== undefined) {
      tmp = true;
    } else {
      exit$1 = 1;
    }
    if (exit$1 === 1) {
      let match$7 = match$5.previousData;
      tmp = match$7 !== undefined && match$7.TAG === "Ok" ? match$7._0.order !== undefined : false;
    }
  } else {
    tmp = false;
  }
  let orderVariantsStockQuery = OrderEdit__Queries.OrderVariantsStockQueryHook.use(skipOrderVariantsStockQuery, tmp, orderId);
  let orderVariantsStockQuery$1 = !skipOrderVariantsStockQuery ? orderVariantsStockQuery : undefined;
  let exit$2 = 0;
  if (orderId !== undefined) {
    let exit$3 = 0;
    if (orderQuery.TAG !== "Executed") {
      return "Loading";
    }
    let match$8 = orderQuery._0;
    if (match$8.data !== undefined || match$8.previousData !== undefined) {
      exit$3 = 2;
    } else {
      if (match$8.loading) {
        return "Loading";
      }
      exit$3 = 2;
    }
    if (exit$3 === 2) {
      if (orderVariantsStockQuery$1 !== undefined && orderVariantsStockQuery$1.data === undefined && orderVariantsStockQuery$1.previousData === undefined) {
        if (orderVariantsStockQuery$1.loading) {
          return "Loading";
        }
        exit$2 = 1;
      } else {
        exit$2 = 1;
      }
    }
  } else {
    exit$2 = 1;
  }
  if (exit$2 === 1) {
    if (typeof authState !== "object") {
      return "Loading";
    }
    if (authState.TAG === "Logging") {
      return "Loading";
    }
    if (authState._0.shops.length === 0) {
      return "Loading";
    }
    if (orderId !== undefined) {
      let match$9 = orderQuery._0;
      let exit$4 = 0;
      let exit$5 = 0;
      let order;
      let match$10 = match$9.data;
      let exit$6 = 0;
      if (match$10 !== undefined) {
        let order$1 = match$10.order;
        if (order$1 !== undefined) {
          order = order$1;
          exit$5 = 3;
        } else {
          exit$6 = 4;
        }
      } else {
        exit$6 = 4;
      }
      if (exit$6 === 4) {
        let match$11 = match$9.previousData;
        if (match$11 !== undefined && match$11.TAG === "Ok") {
          let order$2 = match$11._0.order;
          if (order$2 !== undefined) {
            order = order$2;
            exit$5 = 3;
          } else {
            exit$4 = 2;
          }
        } else {
          exit$4 = 2;
        }
      }
      if (exit$5 === 3) {
        if (orderVariantsStockQuery$1 !== undefined) {
          let exit$7 = 0;
          let orderProducts;
          let match$12 = orderVariantsStockQuery$1.data;
          let exit$8 = 0;
          if (match$12 !== undefined) {
            let match$13 = match$12.order;
            if (match$13 !== undefined) {
              orderProducts = match$13.products.edges;
              exit$7 = 4;
            } else {
              exit$8 = 5;
            }
          } else {
            exit$8 = 5;
          }
          if (exit$8 === 5) {
            let match$14 = orderVariantsStockQuery$1.previousData;
            if (match$14 === undefined) {
              return "Error";
            }
            if (match$14.TAG !== "Ok") {
              return "Error";
            }
            let match$15 = match$14._0.order;
            if (match$15 === undefined) {
              return "Error";
            }
            orderProducts = match$15.products.edges;
            exit$7 = 4;
          }
          if (exit$7 === 4) {
            let updatedStocks = Stdlib_Array.filterMap(orderProducts, param => {
              let orderProduct = param.node;
              let match = orderProduct.variant;
              if (match === undefined) {
                return;
              }
              let quantity = match.stock.rawQuantity;
              if (quantity !== undefined) {
                return {
                  productId: orderProduct.id,
                  rawQuantity: quantity
                };
              }
            });
            return {
              TAG: "Data",
              _0: {
                name: order.formattedName,
                statuses: order.formattedStatus,
                updatedAt: order.updatedAt,
                initialValues: {
                  condition: Stdlib_Option.getOr(order.condition, ""),
                  noteForSupplier: Stdlib_Option.getOr(order.noteForSupplier, ""),
                  supplierId: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => supplier.id), Stdlib_Option.getOr(supplierId, "")),
                  issueDate: order.issueDate,
                  estimatedReceptionDate: order.estimatedReceptionDate,
                  note: Stdlib_Option.getOr(order.note, ""),
                  cart: OrderEdit__Utils.updateCartStocks(Accounting__Serializer.deserialize(order.cart), updatedStocks, order.formattedStatus),
                  shopId: order.shop.id,
                  deviceId: order.device.id,
                  supplierName: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => supplier.companyName), ""),
                  supplierAddress: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                    let node = param.node;
                    let match = node.address;
                    if (match !== undefined) {
                      return node.address;
                    }
                  }), "", (acc, address) => acc + (
                    acc.length > 0 ? " | " : ""
                  ) + address)), ""),
                  supplierPostalCode: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                    let node = param.node;
                    let match = node.postalCode;
                    if (match !== undefined) {
                      return node.postalCode;
                    }
                  }), "", (acc, postalCode) => acc + (
                    acc.length > 0 ? " | " : ""
                  ) + postalCode)), ""),
                  supplierCity: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                    let node = param.node;
                    let match = node.city;
                    if (match !== undefined) {
                      return node.city;
                    }
                  }), "", (acc, city) => acc + (
                    acc.length > 0 ? " | " : ""
                  ) + city)), ""),
                  supplierCountry: Stdlib_Option.getOr(Stdlib_Option.map(order.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                    let node = param.node;
                    let match = node.country;
                    if (match !== undefined) {
                      return node.country;
                    }
                  }), "", (acc, country) => acc + (
                    acc.length > 0 ? " | " : ""
                  ) + country)), "")
                },
                updatedStocks: updatedStocks,
                receptionFinishedAt: order.receptionFinishedAt
              }
            };
          }
        } else {
          exit$4 = 2;
        }
      }
      if (exit$4 === 2) {
        let exit$9 = 0;
        let order$3;
        let match$16 = match$9.data;
        let exit$10 = 0;
        if (match$16 !== undefined) {
          let order$4 = match$16.order;
          if (order$4 !== undefined) {
            order$3 = order$4;
            exit$9 = 3;
          } else {
            exit$10 = 4;
          }
        } else {
          exit$10 = 4;
        }
        if (exit$10 === 4) {
          let match$17 = match$9.previousData;
          if (match$17 === undefined) {
            return "Error";
          }
          if (match$17.TAG !== "Ok") {
            return "Error";
          }
          let order$5 = match$17._0.order;
          if (order$5 === undefined) {
            return "Error";
          }
          order$3 = order$5;
          exit$9 = 3;
        }
        if (exit$9 === 3) {
          return {
            TAG: "Data",
            _0: {
              name: order$3.formattedName,
              statuses: order$3.formattedStatus,
              updatedAt: order$3.updatedAt,
              initialValues: {
                condition: Stdlib_Option.getOr(order$3.condition, ""),
                noteForSupplier: Stdlib_Option.getOr(order$3.noteForSupplier, ""),
                supplierId: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => supplier.id), ""),
                issueDate: order$3.issueDate,
                estimatedReceptionDate: order$3.estimatedReceptionDate,
                note: Stdlib_Option.getOr(order$3.note, ""),
                cart: Accounting__Serializer.deserialize(order$3.cart),
                shopId: order$3.shop.id,
                deviceId: order$3.device.id,
                supplierName: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => supplier.companyName), ""),
                supplierAddress: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                  let node = param.node;
                  let match = node.address;
                  if (match !== undefined) {
                    return node.address;
                  }
                }), "", (acc, address) => acc + (
                  acc.length > 0 ? " | " : ""
                ) + address)), ""),
                supplierPostalCode: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                  let node = param.node;
                  let match = node.postalCode;
                  if (match !== undefined) {
                    return node.postalCode;
                  }
                }), "", (acc, postalCode) => acc + (
                  acc.length > 0 ? " | " : ""
                ) + postalCode)), ""),
                supplierCity: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                  let node = param.node;
                  let match = node.city;
                  if (match !== undefined) {
                    return node.city;
                  }
                }), "", (acc, city) => acc + (
                  acc.length > 0 ? " | " : ""
                ) + city)), ""),
                supplierCountry: Stdlib_Option.getOr(Stdlib_Option.map(order$3.supplier, supplier => Stdlib_Array.reduce(Stdlib_Array.filterMap(supplier.locations.edges, param => {
                  let node = param.node;
                  let match = node.country;
                  if (match !== undefined) {
                    return node.country;
                  }
                }), "", (acc, country) => acc + (
                  acc.length > 0 ? " | " : ""
                ) + country)), "")
              },
              updatedStocks: undefined,
              receptionFinishedAt: order$3.receptionFinishedAt
            }
          };
        }
      }
    } else {
      let match$18 = authState._0;
      let activeShop = match$18.activeShop;
      let match$19;
      if (shopId !== undefined) {
        let shop = match$18.shops.find(shop => shop.id === shopId);
        match$19 = [
          Stdlib_Option.map(shop, shop => shop.id),
          Stdlib_Option.map(shop, shop => shop.activeWebDeviceId)
        ];
      } else {
        match$19 = activeShop !== undefined ? [
            activeShop.id,
            activeShop.activeWebDeviceId
          ] : [
            undefined,
            undefined
          ];
      }
      return makeInitialOrder(supplierId, match$19[0], match$19[1], undefined);
    }
  }
}

let Utils;

let OrderQuery;

let OrderVariantsStockQuery;

let OrderVariantsStockQueryHook;

export {
  Utils,
  OrderQuery,
  OrderVariantsStockQuery,
  OrderVariantsStockQueryHook,
  initialCart,
  makeInitialOrder,
  useQuery,
}
/* initialCart Not a pure module */
